export const videoReferenceSerialiser = (original) => ({
  match_id: original?.matchId,
  match_part: original?.matchPart,
  sport: original?.sport,
  track: original?.track,
  version: original?.version,
});

export default { videoReferenceSerialiser };
